"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFileAttachment = _interopRequireDefault(require("UIComponents/attachment/UIFileAttachment"));

var _FileManager = _interopRequireDefault(require("lead-flows-ui/components/editor/FileManager/FileManager"));

var _userInfo = require("hub-http/userInfo");

var _BrowseButton = _interopRequireDefault(require("FileManagerLib/components/BrowseButton"));

var _DragDropContext = _interopRequireDefault(require("lead-flows-ui/utils/DragDropContext"));

var FileUploadManager =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FileUploadManager, _Component);
  (0, _createClass2.default)(FileUploadManager, null, [{
    key: "propTypes",
    get: function get() {
      return {
        fileUrl: _react.default.PropTypes.string,
        updateDyno: _react.default.PropTypes.func.isRequired
      };
    }
  }]);

  function FileUploadManager(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FileUploadManager);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileUploadManager).call(this, props));
    _this.state = {
      fileUrl: _this.props.fileUrl
    };
    _this.handleFileChange = _this.handleFileChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.clearFile = _this.clearFile.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FileUploadManager, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowThankYouMessage.fileUpload." + suffix;
    }
  }, {
    key: "handleFileChange",
    value: function handleFileChange(data) {
      this.props.updateDyno({
        redirectUrl: data.get('url')
      });
      this.setState({
        fileUrl: data.get('url')
      });
    }
  }, {
    key: "clearFile",
    value: function clearFile() {
      this.props.updateDyno({
        redirectUrl: ''
      });
      this.setState({
        fileUrl: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var fileUrl = this.state.fileUrl;

      if (fileUrl) {
        var fileName = decodeURIComponent(fileUrl.substr(fileUrl.lastIndexOf('/') + 1));
        var pdfExt = '.pdf';
        var isPdf = fileName.slice(-pdfExt.length) === pdfExt;
        return _react.default.createElement(_UIFileAttachment.default, {
          closeable: true,
          onCloseClick: this.clearFile,
          fileName: fileName,
          fileType: isPdf ? 'application/pdf' : null // only PDF files get an icon in this component

        });
      }

      return _react.default.createElement(_FileManager.default, {
        auth: (0, _userInfo.userInfoSync)()
      }, _react.default.createElement(_BrowseButton.default, {
        type: "FILE",
        onSelect: this.handleFileChange
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('browse')
      })));
    }
  }]);
  return FileUploadManager;
}(_react.Component);

var _default = (0, _DragDropContext.default)()(FileUploadManager);

exports.default = _default;
module.exports = exports.default;